import { SyntheticEvent, useRef } from 'react';
import DotsLoading from '../../../components/dotsLoading';
import styles from './footer.module.scss';

type TMessageFooterProps = {
  message: string;
  isLoading: boolean;
  setMessage: (e: string) => void;
  sendMessage: () => void;
};

const MessageFooter = ({
  message,
  isLoading,
  setMessage,
  sendMessage,
}: TMessageFooterProps) => {
  const textRef = useRef<HTMLTextAreaElement>(null);

  const onChangeHandler = function (e: SyntheticEvent) {
    const target = e.target as HTMLTextAreaElement;
    if (textRef.current) {
      textRef.current.style.height = '40px';
      textRef.current.style.height = `${target.scrollHeight}px`;
    }
    setMessage(target.value);
  };

  const handleSendMessage = () => {
    if (!isLoading) {
      sendMessage();
      if (textRef.current) textRef.current.style.height = '40px';
    }
  };

  return (
    <>
      <div className={styles['footer']}>
        <div className="d-flex justify-content-between px-3">
          {isLoading ? (
            <div className="p-0 d-flex justify-content-center align-items-center   ">
              <DotsLoading />
            </div>
          ) : (
            <div className="p-0 d-flex justify-content-center align-items-end ">
              {message ? <i
                className="icon-send color-primary"
                onClick={handleSendMessage}
              ></i> : <i className="icon-send color-gray-1"></i>}

            </div>
          )}

          <div className="w-100 pe-3 d-flex justify-content-center align-items-center">
            <textarea
              ref={textRef}
              onChange={onChangeHandler}
              placeholder="پیام..."
              value={message}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageFooter;
